const CONST = {
    RESET: 'COLOR_BLINDNESS_SIMULATOR/RESET',
    UPDATE_STATE: 'COLOR_BLINDNESS_SIMULATOR/UPDATE_STATE',
    UPDATE_FILES: 'COLOR_BLINDNESS_SIMULATOR/UPDATE_FILES',
};

export default CONST;
